import { APP_PATHS } from 'app-shared/constants';
import { Navigate, useLocation } from 'react-router-dom';

import { useHasPermission } from '@/session/hooks/useHasPermission';

export const HomeRoute = () => {
  const canEditPlanning = useHasPermission('org:planning:edit');
  const { search } = useLocation();
  const homePath = canEditPlanning ? APP_PATHS.planning : APP_PATHS.myPlanning;

  return <Navigate to={`${homePath}${search}`} replace />;
};
